import { ProjectApi } from './project-api.model';

export class Project {
  id: number;
  name: string;

  constructor(resource: ProjectApi) {
    this.id = resource.id;
    this.name = resource.name;
  }
}
